/**
 * MHV Account Utilities
 * Shared utility functions used across account dashboard, consignment, and related pages.
 * Depends on: mhv-config.js (MHV.SERVER_URL)
 */
window.MHV_ACCOUNT = window.MHV_ACCOUNT || {};

/**
 * Format a number as US currency ($X,XXX.XX).
 * Returns '$0.00' for zero/null/undefined.
 * Callers needing 'TBD' for null should check before calling.
 */
MHV_ACCOUNT.formatCurrency = function(amount) {
  if (amount === null || amount === undefined || amount === 0) return '$0.00';
  var num = parseFloat(amount);
  if (isNaN(num)) return '$0.00';
  return '$' + num.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
};

/**
 * Format ISO date string to MM/DD/YYYY.
 */
MHV_ACCOUNT.formatDate = function(isoDate) {
  if (!isoDate) return '';
  var date = new Date(isoDate);
  var month = String(date.getMonth() + 1).padStart(2, '0');
  var day = String(date.getDate()).padStart(2, '0');
  var year = date.getFullYear();
  return month + '/' + day + '/' + year;
};

/**
 * Format auction date code (yyyymmdd) to MM/DD/YYYY.
 * If already in MM/DD/YYYY format, returns as-is.
 */
MHV_ACCOUNT.formatAuctionDate = function(dateStr) {
  if (!dateStr) return 'Unknown';
  if (dateStr.includes('/')) return dateStr;
  var match = dateStr.match(/^(\d{4})(\d{2})(\d{2})$/);
  if (match) {
    return match[2] + '/' + match[3] + '/' + match[1];
  }
  return dateStr;
};

/**
 * Check if an ISO date is overdue (past end of that day).
 */
MHV_ACCOUNT.isOverdue = function(isoDate) {
  if (!isoDate) return false;
  var dueDate = new Date(isoDate);
  var now = new Date();
  dueDate.setHours(23, 59, 59, 999);
  return now > dueDate;
};

/**
 * Format phone number for display.
 */
MHV_ACCOUNT.formatPhone = function(phone) {
  if (!phone) return 'Not set';
  return phone;
};

/**
 * Generate a consignment status badge HTML string.
 */
MHV_ACCOUNT.getConsignmentStatusBadge = function(status) {
  var labels = { 'active': 'Active', 'sold': 'Sold', 'passed': 'Passed', 'backed_out': 'Backed Out' };
  return '<span class="consignment-status-badge consignment-status-' + status + '">' + (labels[status] || status) + '</span>';
};

/**
 * Generate a bid status badge HTML string.
 */
MHV_ACCOUNT.getBidStatusBadge = function(status) {
  var labels = {
    'winning': '\u2713 High Bidder',
    // A BLIND sale (lib/blind-bids.js) says what you bid, never where you stand.
    'bid': 'Bid placed',
    'outbid': '\u2717 Outbid',
    'won': '\uD83C\uDF89 You Won!',
    'lost': 'Sold',
    'passed': 'Passed'
  };
  return '<span class="bid-status-badge bid-status-' + status + '">' + (labels[status] || status) + '</span>';
};

/**
 * Get CSS class for max bid display based on bid status.
 */
MHV_ACCOUNT.getMaxBidClass = function(status) {
  if (status === 'winning' || status === 'won') return 'winning';
  if (status === 'outbid' || status === 'lost') return 'losing';
  return '';
};

/**
 * Toggle an expandable section (add/remove 'expanded' class on parent).
 */
MHV_ACCOUNT.toggleSection = function(header) {
  var section = header.parentElement;
  section.classList.toggle('expanded');
};

/**
 * Deep-link: when the URL has a #<section-id> (e.g. from a notification), expand
 * that section and scroll to it. Sections load async (some are hidden until their
 * data arrives), so we poll briefly for the target to appear + become visible.
 */
MHV_ACCOUNT.deepLinkToSection = function() {
  var hash = (window.location.hash || '').replace(/^#/, '');
  if (!hash) return;
  var tries = 0;
  var timer = setInterval(function() {
    tries++;
    var section = document.getElementById(hash);
    var visible = section && section.offsetParent !== null; // shown (not display:none)
    if (visible) {
      clearInterval(timer);
      section.classList.add('expanded');
      try { section.scrollIntoView({ behavior: 'smooth', block: 'start' }); } catch (e) { section.scrollIntoView(); }
    } else if (tries > 40) { // ~10s max (async section may simply have no data)
      clearInterval(timer);
    }
  }, 250);
};
(function () {
  function run() { MHV_ACCOUNT.deepLinkToSection(); }
  if (document.readyState !== 'loading') run();
  else document.addEventListener('DOMContentLoaded', run);
  // Already on /account and the hash changes (clicked a notification from here).
  window.addEventListener('hashchange', run);
})();
